import { RTImageNode } from '@prismicio/types'
import { FC } from 'react'
import { Utils } from 'common/utils'
import cn from 'classnames'

type PrismicImageProps = {
  image: RTImageNode
  withoutSrcSet?: boolean
  className?: string
  fluid?: boolean
  width?: number
}

export const PrismicImage: FC<PrismicImageProps> = (props) => {
  const split = props.image.url.split('?')
  const url = split[0]
  const paramsObj = Utils.fromParam(split[1])
  let width = paramsObj.w ? parseInt(paramsObj.w) : 0
  let height = paramsObj.h ? parseInt(paramsObj.h) : 0

  if (props.width) {
    const multiplier = props.width / width
    width = parseInt(`${width * multiplier}`)
    height = parseInt(`${height * multiplier}`)
  }

  const sizes = [1.5, 2, 4].map((v) => {
    return `${url}?${encodeURIComponent(
      Utils.toParam({
        ...paramsObj,
        h: height ? height * v : undefined,
        w: width ? width * v : undefined,
      }),
    )} ${v}x`
  })

  const srcSet = {
    height,
    srcset: `${props.image.url.replace(/,/g, '%25')}, ${sizes.join(',')}`,
    width,
  }

  return (
    <img
      loading='lazy'
      className={cn('img-fluid', props.className)}
      srcSet={props.withoutSrcSet ? undefined : srcSet.srcset}
      width={
        props.fluid ? undefined : srcSet.width || props.image.dimensions.width
      }
      height={
        props.fluid ? undefined : srcSet.height || props.image.dimensions.width
      }
      src={props.image.url.replace(/,/g, '%25')}
      alt={props.image.alt || ''}
    />
  )
}

export default PrismicImage
